import type {
  AttributeFilters,
  Filters,
  SnapshotId,
  TableRequestBody,
  TableRequestColumns,
  TableResponseBody,
} from '@ipfabric/utils';

import type { ApiRequestFunction } from 'utils/request/useApi';

interface TableSettings<TRow> {
  columns: TableRequestColumns<TRow>;
  filters: Filters;
  pagination: { start: number; limit: number };
  snapshotId: SnapshotId;
}

export const loadAttributesSummaryTable = async <TAttributesSummary,>(
  apiRequest: ApiRequestFunction,
  tableSettings: TableSettings<TAttributesSummary>,
  attributeFilters: AttributeFilters,
): Promise<TableResponseBody<TAttributesSummary>> =>
  apiRequest<
    TableResponseBody<TAttributesSummary>,
    TableRequestBody<TAttributesSummary>
  >({
    url: '/tables/attributes/graphs',
    method: 'POST',
    data: {
      columns: tableSettings.columns,
      filters: tableSettings.filters,
      snapshot: tableSettings.snapshotId,
      attributeFilters,
      ...(tableSettings.pagination !== undefined && {
        pagination: tableSettings.pagination,
      }),
    },
  });
